import { Component } from '@angular/core';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.scss',
  host: {
    class: 'row flex-grow-1'
  },
    standalone: false
})
export class ContactUsComponent {

}
